module.exports = __webpack_public_path__ + "img/glamping_2.5e31df85.jpg";